<script setup lang="ts">
defineProps({
    title: {
        type: String,
        default: '',
    },
});
</script>

<template>
    <div class="privacy-item privacy__item">
        <div class="privacy-item__title"></div>
        <div class="privacy-item__content">
            <h1 class="privacy-item__headline">
                {{ title }}
            </h1>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>